import { stepStatus } from '../StudioStepper';

export const MTV_STEPS = [
  { id: 1, label: 'Song' },
  { id: 2, label: 'Sound' },
  { id: 3, label: 'Cast & Places' },
  { id: 4, label: 'Inspiration & Look' },
  { id: 5, label: 'Storyboard' },
  { id: 6, label: 'Produce' },
  { id: 7, label: 'Mix & Final Cut' },
];

export const mmss = (t) => `${Math.floor((t || 0) / 60)}:${String(Math.floor((t || 0) % 60)).padStart(2, '0')}`;

export const hasStems = (project) => {
  const s = project.mtv?.stems;
  return !!(s?.vocals && s.source && s.source === project.music?.url);
};

/** Music-video wizard progress, derived from the project — nothing is hard-locked. */
export function mtvStepStatus(project, styleLabel) {
  const base = stepStatus(project, styleLabel);
  const m = project.mtv || {};
  const music = project.music || {};
  const scenes = project.scenes || [];
  const lead = (project.show_kit || []).find((k) => k.lead_singer);
  const notes = (project.inspiration?.notes || []).filter((n) => n.on).length;
  const story = (project.story?.scenes || []).length;
  const bpm = m.analysis?.bpm ? ` · ${Math.round(m.analysis.bpm)} BPM` : '';
  return {
    1: { done: !!music.url && !!(m.lines?.length || project.lyrics), hint: !music.url ? 'Upload your song' : m.lines?.length ? `${m.lines.length} lines${bpm}` : 'Lyrics needed' },
    2: { done: !!music.url, hint: music.source === 'mtv' ? 'New version in use' : hasStems(project) ? 'Vocals split' : 'Optional' },
    3: { done: !!lead, hint: lead ? `Lead · ${lead.name}` : 'Pick the lead singer' },
    4: { done: !!project.render_style, hint: [styleLabel, notes ? `${notes} notes` : ''].filter(Boolean).join(' · ') || 'Pick a look' },
    5: { done: scenes.length > 0, hint: scenes.length ? `${story || '—'} scenes · ${scenes.length} shots` : 'Not written yet' },
    6: base[5],
    7: base[7],
  };
}
